// src/context/QrCodeModalContext.tsx
import React, { createContext, useContext, useState } from "react";

interface QrCodeData {
  compraId: number;
  base64?: string;
  url?: string;
}


interface QrCodeModalContextProps {
  isOpen: boolean;
  qrCodeData: QrCodeData | null;
  openModal: (data: QrCodeData) => void;
  closeModal: () => void;
}

const QrCodeModalContext = createContext<QrCodeModalContextProps | undefined>(
  undefined
);

export const QrCodeModalProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [qrCodeData, setQrCodeData] = useState<QrCodeData | null>(null);

  const openModal = (data: QrCodeData) => {
    setQrCodeData(data);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setQrCodeData(null);
  };

  return (
    <QrCodeModalContext.Provider value={{ isOpen, qrCodeData, openModal, closeModal }}>
      {children}
    </QrCodeModalContext.Provider>
  );
};

export const useQrCodeModal = () => {
  const context = useContext(QrCodeModalContext);
  if (!context) {
    throw new Error("useQrCodeModal must be used within QrCodeModalProvider");
  }
  return context;
};
